export default __webpack_public_path__ + "static/media/testausserveri.428b5598.jpeg";